// The server reprices every add-on line from the live addon_services rate and
// rejects the save (400 VALIDATION) when the client's total doesn't match.
// Add-on lines carry a rate snapshot in breakdown.addon that can go stale
// (an existing quote reopened after a rate change, or a cached add-on catalog),
// so this must be refreshed client-side before a save or the save is rejected.
import { getAddonLineMarker, priceAddonLine, type AddonService } from '@wrapforce/shared';

export function reconcileAddonLines<
  T extends { estimatedMinutes?: number | null; lineTotalCents?: number; breakdown?: Record<string, unknown> | null },
>(lines: T[], addons: AddonService[]): { lines: T[]; changed: boolean } {
  let changed = false;
  const nextLines = lines.map((line) => {
    const marker = getAddonLineMarker(line.breakdown);
    if (!marker) return line;
    const addon = addons.find((a) => a.id === marker.addonServiceId);
    if (!addon) return line;
    if (marker.rateCents === addon.rateCents && marker.pricingType === addon.pricingType) return line;

    const minutes = addon.pricingType === 'hourly'
      ? (line.estimatedMinutes ?? 0)
      : (line.estimatedMinutes ?? addon.estimatedMinutes ?? 0);
    const cents = priceAddonLine({ pricingType: addon.pricingType, rateCents: addon.rateCents, minutes }).cents;

    changed = true;
    return {
      ...line,
      estimatedMinutes: minutes,
      lineTotalCents: cents,
      breakdown: { ...(line.breakdown ?? {}), addon: { addonServiceId: addon.id, pricingType: addon.pricingType, rateCents: addon.rateCents, minutes } },
    };
  });

  return changed ? { lines: nextLines, changed: true } : { lines, changed: false };
}
